import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { SnMenuModule } from '@lib/ui/menu';

import { SnColorPickerControl } from './components/control/color-picker.control';
import { SnColorPickerFormField } from './components/form-field/color-picker.form-field';
import { ColorNameTranslationPipe } from './pipes/color-name-translation.pipe';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatRippleModule,
    MatTooltipModule,
    // Transloco
    TranslationModule,
    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'color-picker',
          component: SnColorPickerFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
    // Libs
    SnMenuModule,
    SnIconModule,
    SnButtonModule,
  ],
  exports: [SnColorPickerControl, ColorNameTranslationPipe],
  declarations: [SnColorPickerControl, SnColorPickerFormField, ColorNameTranslationPipe],
})
export class SnFormColorPickerModule {}
